import type { CSSProperties, ForwardedRef, Key, ReactElement } from 'react';
import { forwardRef, useState } from 'react';
import { useRect } from 'react-use-rect';

type MasonryItemProps = {
  item: ReactElement;
  key: Key;
  style: CSSProperties;
};

type HeightObservableMasonryItemProps = MasonryItemProps & {
  onHeightChange?: (newHeight: number) => void;
};

export const MasonryItem = forwardRef(function (
  { item, key, style }: MasonryItemProps,
  ref?: ForwardedRef<HTMLDivElement>
) {
  return (
    <div key={key} ref={ref} style={style}>
      {item}
    </div>
  );
});

export function HeightObservableMasonryItem({
  item,
  key,
  style,
  onHeightChange
}: HeightObservableMasonryItemProps) {
  const [itemHeight, setItemHeight] = useState(0);
  const [ref] = useRect(
    ({ height }) => {
      if (itemHeight !== height) {
        setItemHeight(height);
        onHeightChange?.(height);
      }
    },
    { resize: true }
  );

  return <MasonryItem key={key} item={item} style={style} ref={ref} />;
}
